// 将所有请求全部封装在外部，为了方便复用和统一的维护
import request from '_utils/request'

// 登陆
const doLogin = (params = {}) => request.get('/login', { params })
// 获取验证码
const ValidCode = (params = {}) => request.get('/captcha', { params })
// ApiToken
const GetApiToken = (params = {}) => request.get('/token')
// 退出登录
const logOut = (params = {}) => request.post('/users/logout', params)
// ****************************
// 域名列表
const dnsList = (params = {}) => request.get('/domains', { params })
// 添加域名
const ADDDomains = (params = {}) => request.post('/domains', params)
// 批量添加域名
const ADDBatchDomains = (params = {}) => request.post('/domains/batchStore', params)
// 修改域名及单个修改状态
const EITDomains = (params = {}) => request.put('/domains/' + params.id, params)
// 域名详情
const EITDetails = (params = {}) => request.get('/domains/' + params.id)
// 删除域名
const DELDomains = (params = {}) => request.delete('/domains/' + params.id)
// 批量删除域名
const batchDestroy = (params) => request.delete('/domains/batchDestroy', { data: params })
// 申请证书
const batchSetHttps = (params = {}) => request.put('/domains/batchUpdate', params)
// 更换跳转地址
const batchToDomain = (params = {}) => request.put('/domains/batchUpdateToDomain', params)
// 下载证书
const updatedHTTPS = (params = { }) => request.post('/domains/certDownload?id=' + params.id, params)
// 域名解析
const AnalyzeDomains = (params = {}) => request.post('/domains/dns' , params)
// 更换跳转地址2
const batchToDomain2 = (params = {}) => request.put('/domains/updateJumpAddress', params)

// 更换跳转地址 （1电脑端、2手机端）
const jumpAddressUpdate  = (params = {}) => request.put('/domains/jumpAddressUpdate', params)
// 模糊查询域名列表
const matchDomainAll = (params = {}) => request.get('/domains/matchDomainAll?match_domain=' + params.match_domain+'&group_id='+params.group_id)
// 模糊查询 电脑端 手机端列表
const jumpAddressGroup = (params = {}) => request.post('/domains/jumpAddressGroup' , params)
// 添加域名 查找库中是否存在当前域名提示接口
const domainRepeat  = (params = {}) => request.post('/domains/domainRepeat' , params)

// 批量编辑 1
const batchEdit = (params = {}) => request.put('/domains/batchEdit', params)

// 批量编辑 2
const batchEditJumpAddress = (params = {}) => request.put('/domains/batchEditJumpAddress', params)
// *******************************
// 首页
const Homes = (params = {}) => request.get('/homes', { params })
// 列表
const Articles = (params = {}) => request.get('/articles', { params })
// 修改
const EITArticles = (params = {}) => request.put('/articles/' + params.id, params)
// **********************************
// 分组列表
const groupsList = (params = {}) => request.get('/groups', { params })
// 添加分组
const ADDGroup = (params = {}) => request.post('/groups', params)
// 删除分组
const delGroup = (params = {}) => request.delete('/groups/' + params.id)
// 修改分组
const eitGroup = (params = {}) => request.put('/groups/' + params.id, params)
// 替换跳转地址
const replaceUrl = (params = {}) => request.put('/domains/replaceUrl', params)

// ************************************
// 用户列表
const userList = (params = {}) => request.get('/users', { params })
// 用户详情
const userDetails = (params = {}) => request.get('/users/' + params.id)
// 添加用户
const ADDUser = (params = {}) => request.post('/users', params)
// 删除用户
const delUser = (params = {}) => request.delete('/users/' + params.id)
// 修改用户
const eitUser = (params = {}) => request.put('users/' + params.id, params)

// 用户访问域名
// const eitUser = (params = {}) => request.put('users/' + params.id, params)

// ************************************
// 节点列表
const permissionsList = (params = {}) => request.get('/permissions', { params })
// 添加节点
const ADDPermissions = (params = {}) => request.post('/permissions', params)
// 删除节点
const delPermissions = (params = {}) => request.delete('/permissions/' + params.id)
// 修改节点
const eitPermissions = (params = {}) => request.put('/permissions/' + params.id, params)

// 端口列表
const nodePortsList = (params = {}) => request.get('/nodePorts', {params}  )
// 添加端口
const ADDPort = (params = {}) => request.post('/nodePorts', params)
// 删除端口
const delPort = (params = {}) => request.delete('/nodePorts/' + params.port,{params})

// 获取全部数据
const nodeGetAllData = (params = {}) => request.get('/ipNodes/getAllData', {params}  )

// ************************************
// 角色列表
const rolesList = (params = {}) => request.get('/roles', { params })
// 添加角色
const ADDRoles = (params = {}) => request.post('/roles', params)
// 删除角色
const delRoles = (params = {}) => request.delete('/roles/' + params.id)
// 修改角色
const eitRoles = (params = {}) => request.put('/roles/' + params.id, params)
// 角色详情
const roleDetails = (params = {}) => request.get('/roles/' + params.id)
// ************************************
// 节点列表
const NodesList = (params = {}) => request.get('/nodes', { params })
// 添加节点
const ADDNodes = (params = {}) => request.post('/nodes', params)
// 删除节点
const delNodes = (params = {}) => request.delete('/nodes/' + params.id)
// 修改节点
const eitNodes = (params = {}) => request.put('/nodes/' + params.id, params)

// **********************************
// DNS列表
const DNSList = (params = {}) => request.get('/dns', { params })
// 添加DNS
const ADDDNS = (params = {}) => request.post('/dns', params)
// 删除DNS
const delDNS = (params = {}) => request.delete('/dns/' + params.id)
// 修改DNS
const eitDNS = (params = {}) => request.put('/dns/' + params.id, params)
// DNS详情
const DNSDetails = (params = {}) => request.get('/dns/' + params.id)

// **********************************
// 日志列表
const journalList = (params = {}) => request.get('/apiLogs', { params })
// 删除日志
const delJournal = (params = {}) => request.delete('/apiLogs/' + params.id)
// 批量删除日志
const batchJournal = (params) => request.delete('/apiLogs/batchDestroy', { data: params })
// **********************************
// IP列表
const IPList = (params = {}) => request.get('/getIps', { params })
// **********************************
// 域名备份
const backupsList = (params = {}) => request.get('/domain/csvLists', { params })
// 备份下载
const backupsDownload = (params = {}) => request.get('/file/downloads?path='+params.item)
// **********************************
// 操作日志
const domainLogs = (params = {}) => request.get('/domainLogs', { params })
// **********************************
// 区域屏蔽
// 列表
const regionsList = (params = {}) => request.get('/regions', { params })
// 添加
const regionsAdd = (params = {}) => request.post('/regions', params)
//详情
const regionsDetails = (params = {}) => request.get('/regions/' + params.id)
// 修改
const regionsEit = (params = {}) => request.put('/regions/' + params.id, params)
// 删除
const regionsDel = (params = {}) => request.delete('/regions/' + params.id)
// 域名备份批量修改
const regionsAllEit = (params = {}) => request.put('/domains/updateCountry', params)


// **********************************
// 设置
// 列表
const systemsList = (params = {}) => request.get('/systems', { params })
// 添加
const systemsAdd = (params = {}) => request.post('/systems', params)
//详情
const systemsDetails = (params = {}) => request.get('/systems/' + params.attr)
// 修改
const systemsEit = (params = {}) => request.put('/systems/' + params.id, params)
// 删除
const systemsDel = (params = {}) => request.delete('/systems/' + params.id)

// **********************************
// DNS设置
//列表
const dnsSetList = (params = {}) => request.get('/dnsSets',{ params })
// 修改
const dnsSetEit = (params = {}) => request.put('/dnsSets/' + params.id, params)

// **********************************
// cname域名
// 列表
const dnsDomainsList = (params = {}) => request.get('/dnsDomains', { params })
// 添加
const dnsDomainsAdd = (params = {}) => request.post('/dnsDomains', params)
//详情
const dnsDomainsDetails = (params = {}) => request.get('/dnsDomains/' + params.attr)
// 修改
const dnsDomainsEit = (params = {}) => request.put('/dnsDomains/' + params.id, params)
// 删除
const dnsDomainsDel = (params = {}) => request.delete('/dnsDomains/' + params.id)
// 批量删除cname域名
const dnsDomainsBatchDestroy = (params) => request.delete('/dnsDomains/batchDestroy', { data: params })

// **********************************
// 新节点管理
// 列表
const ipNodesList = (params = {}) => request.get('/ipNodes', { params })
// 添加
const ipNodesAdd = (params = {}) => request.post('/ipNodes', params)
//详情
const ipNodesDetails = (params = {}) => request.get('/ipNodes/' + params.attr)
// 修改
const ipNodesEit = (params = {}) => request.put('/ipNodes/' + params.id, params)
// 删除
const ipNodesDel = (params = {}) => request.delete('/ipNodes/' + params.id)
// 批量启用禁用IP
const batchUpdateIpStatus = (params = {}) => request.put('/ipNodes/batchUpdateIpStatus', params)
// 批量启用禁用节点
const batchUpdateNodeStatus = (params = {}) => request.put('/ipNodes/batchUpdateNodeStatus', params)
// 批量删除IP
const ipsBatchDestroy = (params) => request.delete('/ipNodes/batchDestroy', { data: params })

// 批量删除节点
const NodesBatchDestroy = (params) => request.delete('/ipNodes/batchDestroyNode', { data: params })
// **********************************
// 线路分组
// 列表
const lineGroupsList = (params = {}) => request.get('/lineGroups', { params })
// 添加
const lineGroupsAdd = (params = {}) => request.post('/lineGroups', params)
//详情
const lineGroupsDetails = (params = {}) => request.get('/lineGroups/' + params.id)
// 修改
const lineGroupsEit = (params = {}) => request.put('/lineGroups/' + params.id, params)
// 删除
const lineGroupsDel = (params = {}) => request.delete('/lineGroups/' + params.id)
// 批量删除线路分组
const lGatchDestroy = (params) => request.delete('/lineGroups/batchDestroy', { data: params })

// **********************************
// 线路分组---设置解析
// 列表
const lineGroupIpNodesList = (params = {}) => request.get('/lineGroupIpNodes', { params })
// 添加
const lineGroupIpNodesAdd = (params = {}) => request.post('/lineGroupIpNodes/batchStore', params)
// 删除
const lineGroupIpDel = (params = {}) => request.delete('/lineGroups/' + params.id)
// 批量启用禁用节点
const lineGroupIpNodesStatus = (params = {}) => request.put('/lineGroupIpNodes/batchUpdateStatus', params)
// 批量修改主备
const lineGroupIpNodesIsMaster = (params = {}) => request.put('/lineGroupIpNodes/batchUpdateIsMaster', params)
// 批量删除线路分组
const lineGroupIpNodesDel = (params) => request.delete('/lineGroupIpNodes/batchDestroy', { data: params })
// **********************************
// 监控报警---报警管理
// 列表
const alarmsList = (params = {}) => request.get('/alarms', { params })
// 添加
const alarmsAdd = (params = {}) => request.post('/alarms', params)
// 删除
const alarmsDel = (params = {}) => request.delete('/alarms/' + params.id)
// 修改
const alarmsEit = (params = {}) => request.put('/alarms/' + params.id, params)
// 批量删除
const alarmsDels = (params = {}) => request.delete('/alarms/batchDestroy',   { data: params })

// 监控报警---报警分组
// 列表
const alarmGroupsList = (params = {}) => request.get('/alarmGroups', { params })
// 添加
const alarmGroupsAdd = (params = {}) => request.post('/alarmGroups', params)
// 删除
const alarmGroupsDel = (params = {}) => request.delete('/alarmGroups/' + params.id)
// 修改
const alarmGroupsEit = (params = {}) => request.put('/alarmGroups/' + params.id, params)
export {
  nodeGetAllData,
  alarmsDels,
  alarmGroupsEit,
  alarmGroupsDel,
  alarmGroupsAdd,
  alarmGroupsList,
  alarmsList,
  alarmsAdd,
  alarmsDel,
  alarmsEit,
  batchEditJumpAddress,
  batchEdit,
  NodesBatchDestroy,
  lineGroupIpDel,
  lineGroupIpNodesDel,
  lineGroupIpNodesIsMaster,
  lineGroupIpNodesStatus,
  lineGroupIpNodesAdd,
  dnsDomainsBatchDestroy,
  lGatchDestroy,
  batchUpdateNodeStatus,
  ipsBatchDestroy,
  batchUpdateIpStatus,
  lineGroupIpNodesList,
  lineGroupsList,
  lineGroupsAdd,
  lineGroupsDetails,
  lineGroupsEit,
  lineGroupsDel,
  ipNodesList,
  ipNodesAdd,
  ipNodesDetails,
  ipNodesEit,
  ipNodesDel,
  dnsDomainsList,
  dnsDomainsAdd,
  dnsDomainsDetails,
  dnsDomainsEit,
  dnsDomainsDel,
  dnsSetList,
  dnsSetEit,
  systemsList,
  systemsAdd,
  systemsDetails,
  systemsEit,
  systemsDel,
  regionsList,
  regionsAdd,
  regionsDetails,
  regionsEit,
  regionsDel,
  regionsAllEit,
  backupsDownload,
  backupsList,
  doLogin,
  userDetails,
  roleDetails,
  dnsList,
  groupsList,
  userList,
  ADDGroup,
  ADDDomains,
  EITDomains,
  DELDomains,
  ADDBatchDomains,
  batchSetHttps,
  EITDetails,
  batchDestroy,
  Homes,
  delGroup,
  // replaceUrl,
  eitGroup,
  delUser,
  eitUser,
  ADDUser,
  permissionsList,
  ADDPermissions,
  delPermissions,
  eitPermissions,
  eitRoles,
  delRoles,
  ADDRoles,
  rolesList,
  logOut,
  // batchToDomain,
  Articles,
  EITArticles,
  NodesList,
  ADDNodes,
  delNodes,
  eitNodes,
  ValidCode,
  updatedHTTPS,
  DNSList,
  ADDDNS,
  delDNS,
  eitDNS,
  DNSDetails,
  journalList,
  delJournal,
  batchJournal,
  IPList,
  nodePortsList,
  ADDPort,
  delPort,
  AnalyzeDomains,
  GetApiToken,
  // batchToDomain2,
  matchDomainAll,
  jumpAddressGroup,
  jumpAddressUpdate,
  domainRepeat,
  domainLogs
}
